"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const heap_1 = require("./heap");
const stack_1 = require("./stack");
const tags_1 = require("./tags");
//main class to utilize for interpreter
class MemoryModel {
    constructor(stack_size, stack_addr_begin, heap_size, heap_addr_begin) {
        this.stack = new stack_1.default(stack_size, stack_addr_begin);
        this.word_size = 8;
        this.heap = new heap_1.default(this.word_size, heap_size);
        this.heap.init();
        this.stack_addr_range = [stack_addr_begin, stack_size + stack_addr_begin];
        this.heap_addr_range = [heap_addr_begin, heap_addr_begin + heap_size];
        this.heap_addr_begin = heap_addr_begin;
        //heap goes here
    }
    //GENERAL STUFF
    mem_write_to_address(address, tag, x) {
        const heap_addr_begin = this.heap_addr_range[0];
        const heap_addr_end = this.heap_addr_range[1];
        if (address < heap_addr_begin) {
            // TODO: include a runtime error
            return this.stack.stack_set_tag_and_value(address, tag, x);
        }
        else if (address >= heap_addr_begin && address < heap_addr_end) {
            return this.heap.set_tag_and_value(address - heap_addr_begin, tag, x);
        }
        return Error('should have added to memory at this point');
    }
    mem_read(address) {
        const heap_addr_begin = this.heap_addr_range[0];
        const heap_addr_end = this.heap_addr_range[1];
        if (address < heap_addr_begin) {
            return this.stack.stack_get_tag_and_value(address);
        }
        else if (address >= heap_addr_begin && address < heap_addr_end) {
            return this.heap.get_tag_and_value(address - heap_addr_begin);
        }
        throw Error('Memory only supports heap and stack');
    }
    from_stack(address) {
        return address < this.stack_addr_range[1] && address >= this.stack_addr_range[0];
    }
    from_heap(address) {
        return address < this.heap_addr_range[1] && address >= this.heap_addr_range[0];
    }
    //HEAP METHODS
    mem_heap_allocate_one() {
        return this.heap.allocate_one() + this.heap_addr_begin;
    }
    mem_heap_allocate_n(n) {
        return this.heap.allocate_n(n) + this.heap_addr_begin;
    }
    mem_heap_free(address) {
        this.heap.free_up_memory(address - this.heap_addr_begin);
    }
    //STACK METHODS
    mem_stack_push(tag, x) {
        return tag === tags_1.TAGS.int_tag
            ? this.stack.push_int(x)
            : tag === tags_1.TAGS.float_tag
                ? this.stack.push_float(x)
                : tag === tags_1.TAGS.char_tag
                    ? this.stack.push_char(x)
                    : tag === tags_1.TAGS.int_pointer_tag ||
                        tag === tags_1.TAGS.float_pointer_tag ||
                        tag === tags_1.TAGS.char_pointer_tag
                        ? this.stack.push_pointer(tag, x)
                        : tag === tags_1.TAGS.void_tag
                            ? this.stack.push(tags_1.TAGS.void_tag, 0)
                            : null;
    }
    mem_stack_allocate_one() {
        return this.stack.allocate_one();
    }
    mem_stack_deallocate_one() {
        this.stack.deallocate_one();
    }
    mem_stack_deallocate_n(n) {
        for (let i = 0; i < n; i++) {
            this.stack.deallocate_one();
        }
    }
    mem_stack_allocate_n(n) {
        return this.stack.allocate_n(n);
    }
    enter_scope() {
        //currently, only stack is involved with scope. heap is not involved
        this.stack.enter_scope();
    }
    exit_scope() {
        this.stack.exit_scope();
    }
    return_statement(address) {
        //exit scope but with return
        return this.stack.return_and_exit_scope(address);
    }
}
exports.default = MemoryModel;
//# sourceMappingURL=memoryModel.js.map